/**
 * Сервис зоны доставки
 * @module API/locations
 * @requires API/client
 * */

import client from './client'

/**
 * @const {String} - URL префикс сервиса
 * */
const PREFIX = '/geo'

/**
 * Получить список зон магазина
 * @function
 * @param {String} shop_id
 * @return {Promise}
 * */
export const getShopAreas = (shop_id) => client.get('/shops/shops_areas', {
  params: {
    shop_id
  }
})

/**
 * получить геометрии зоны
 * @function
 * @param {String} areaId
 * @return {Promise}
 * */
export const getAreaWithShapes = (areaId) => client.get(`${PREFIX}/area/${areaId}/shapes`)

/**
 * Получить оции зоны
 * @function
 * @param {String} area_id
 * @param {String} shop_id
 * @return {Promise}
 * */
export const getAreaOptions = (area_id, shop_id) => client.get(
  '/delivery_options',
  {
    params: {
      area_id,
      shop_id
    }
  }
)

/**
 * Установить интервалы
 * @function
 * @param {Object} option
 * @return {Promise}
 * */
export const setOptionIntervals = (option) => client.post(
  '/delivery/option/interval',
  option
)

/**
 * Установить стоимость
 * @function
 * @param {Object} option
 * @return {Promise}
 * */
export const setOptionCosts = (option) => client.post(
  '/delivery/option/cost',
  option
)
/**
 * Создать опцию доставкм
 * @function
 * @param {Object} option
 * @return {Promise}
 * */
export const createOption = ({ shop_id, area_id }) => client.post(
  '/delivery_option',
  {
    shop_id,
    area_id
  }
)

/**
 * Создать зону
 * @function
 * @param {Object} item
 * @param {String} item.area_name
 * @param {String} item.area_description
 * @param {Boolean} item.area_is_hidden
 * @param {String} item.area_type
 * @param {String} item.shop_id
 * @param {Array.<Array.<Object>>} item.geometry
 * @return {Promise}
 * */
export const createArea = (item) => client.post(`${PREFIX}/link_area_shop`, item)

/**
 * Обновить зону
 * @function
 * @param {Object} item
 * @param {String} item.area_name
 * @param {String} item.area_description
 * @param {Boolean} item.area_is_hidden
 * @param {String} item.area_type
 * @param {String} item.shop_id
 * @param {Array.<Array.<Object>>} item.geometry
 * @return {Promise}
 * */
export const updateArea = (item) => client.patch(`${PREFIX}/area/${item.id}`, item)

/**
 * Удалить зону
 * @function
 * @param {String} id
 * @return {Promise}
 * */
export const deleteArea = (id) => client.delete(`${PREFIX}/area/${id}`)

/**
 * Создать фигуру в зоне
 * @function
 * @param {Object} shape
 * @return {Promise}
 * */
export const createAreaShape = (shape) => client.post(
  `${PREFIX}/area/${shape.area_id}/shape`,
  shape
)

/**
 * Обновить фигуру
 * @function
 * @param {Object} shape
 * @return {Promise}
 * */
export const updateAreaShape = (shape) => client.patch(
  `${PREFIX}/shape/${shape.shape_id}`,
  shape
)

/**
 * Удалить фигуру
 * @function
 * @param {String} shapeId
 * @return {Promise}
 * */
export const deleteAreaShape = (shapeId) => client.delete(`${PREFIX}/shape/${shapeId}`)
